import styled from 'styled-components';

// Helpers
import mq from '~/App/helpers/mq';
import { heading4 } from '~/App/helpers/mixins';

export const Header = styled.h4`
  ${heading4};
  line-height: 1;
  display: block;
  color: ${(props) => props.theme.colors.darkBlue};
  text-align: center;
  padding: 0.8125rem 2.75rem;
  cursor: pointer;
  position: relative;

  ${mq('≥large')`
    padding: 0 4.5rem 0 2.75rem;
  `};
`;
